import styled from 'styled-components';

const FileClose = styled.div`
    cursor: pointer;
    margin-top: 0.813rem;
    float: right;
    width: 1.625rem;
    height: 1.625rem;
    line-height: 1.625rem;
    background-color: ${props => props.theme.color};
    color: #FFF;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    span {
        vertical-align: -1px;
        margin-left: 1px;
    }
    flex: 0 0 auto;
`;

export default FileClose;